exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-document .modal-dialog{max-width:60vw}#customer-show-document #show_document_content .ql-container{height:250px;overflow-y:scroll}", ""]);

// exports
